var exports = {
  "aA": "xaee3c4fa--c68338--list-blocked",
  "vl": "xaee3c4fa--c68338--list-blocked_title",
  "KJ": "xaee3c4fa--c68338--list-blocked_text",
  "nl": "xaee3c4fa--c68338--list-blocked_link",
};

module.exports = exports;
